module.exports = __webpack_public_path__ + "img/12.2388c609.png";